import React, { useState } from "react";
import { createPortal } from "react-dom";
import Layout from "../Layout/Layout";
import { signout, isAuthenticated } from "../auth";
import { sendMessageHelp } from "../auth/apiMessage";
import Modal from 'react-bootstrap/Modal';
import { laguangeElakay } from "../pageInside/dataElakay";
import {
    privacyPolicy,
    interpretationDefinitions,
    CollectingUsingYourPersonalData,
    DetailedInformationProcessingYourPersonalData,
    YourCaliforniaPrivacyRights,
    LinksOtherWebsites,
    ChangesthisPrivacyPolicy,
    ContactUs,
    TermsConditions,
    ReturnAndRefundPolicy,
    InterpretationDefinitions,
    YourOrderCancellationRights,
    ConditionsReturns,
    ReturningGoods,
    Exchanges,
    Gifts,
} from '../pageInside/conditionTherm';
import './HelpContact.css';
import './HowToStep.css';
import { elakayAutoText } from "../pageInside/dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["helpContact"]?.[key] || fallback;

// Import du CSS premium

const HC_TOC_ITEMS = [
    { id: 'hc-s-0',  key: "h_9db108ba6b7f65", fallback: "Privacy Policy" },
    { id: 'hc-s-1',  key: "h_86ba1cff4dd7cd", fallback: "Interpretation and Definitions" },
    { id: 'hc-s-2',  key: "h_1c6c13171e6e96", fallback: "Collecting and Using Your Personal Data" },
    { id: 'hc-s-3',  key: "h_1131f2149d5200", fallback: "Detailed Information on Processing" },
    { id: 'hc-s-4',  key: "h_0babf57578641c", fallback: "Your California Privacy Rights" },
    { id: 'hc-s-5',  key: "h_1d52ab97a639fe", fallback: "Links to Other Websites" },
    { id: 'hc-s-6',  key: "h_4c17142b59b91b", fallback: "Changes to this Privacy Policy" },
    { id: 'hc-s-7',  key: "h_9ad0ccff7c6087", fallback: "Contact Us" },
    { id: 'hc-s-8',  key: "h_894031ed8d341b", fallback: "Terms and Conditions" },
    { id: 'hc-s-9',  key: "h_6f95f391b21c4b", fallback: "Return and Refund Policy" },
    { id: 'hc-s-10', key: "h_86ba1cff4dd7cd", fallback: "Interpretation and Definitions" },
    { id: 'hc-s-11', key: "h_a4b9ca6b930cc9", fallback: "Your Order Cancellation Rights" },
    { id: 'hc-s-12', key: "h_350ddc3031cd2c", fallback: "Conditions for Returns" },
    { id: 'hc-s-13', key: "h_fa88b84c1f8da2", fallback: "Returning Goods" },
    { id: 'hc-s-14', key: "h_a55af0b5c6b159", fallback: "Exchanges" },
    { id: 'hc-s-15', key: "h_3b2c3fdb3a879c", fallback: "Gifts" },
];

const HelpContact = (props) => {
    const { infoSource } = props;
    __setElakayInfoSource(infoSource);

    const [showContactUs, setShowContactUs] = useState(false);
    const [tocMinimized, setTocMinimized] = useState(false);
    const [activeTocId, setActiveTocId] = useState(null);

    const { token, a } = isAuthenticated();
    const [values, setValues] = useState({
        userReceived: "5ee5a77cc9ed3415300c10b2",
        userSend: a,
        tilte: "",
        description: ""
    });

    const {
        userReceived,
        userSend,
        tilte,
        description
    } = values;

    const handleChange = name => event => {
        const value = event.target.value;
        setValues({ ...values, [name]: value });
    };

    const handleTocClick = (id) => {
        setActiveTocId(id);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const newPostForm = () => (
        <div className="contact-form-container">
            <div className="contact-form-card">
                <form className="contact-form">
                    <div className="form-group-premium">
                        <label className="form-label-premium">
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).title}
                        </label>
                        <input
                            onChange={handleChange('tilte')}
                            type="text"
                            className="form-control-premium"
                            value={tilte}
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).helpContact.t001}
                        />
                    </div>

                    <div className="form-group-premium">
                        <label className="form-label-premium">
                            {infoSource.laguangeElakay('sellPage', infoSource.languageAPI).description}
                        </label>
                        <textarea
                            onChange={handleChange('description')}
                            className="form-control-premium textarea-premium"
                            rows="6"
                            value={description}
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).helpContact.t002}
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            onClick={() => setShowContactUs(false)}
                            className="btn-secondary-premium"
                        >{__elakayText("t004", "Cancel")}</button>
                        <button
                            type="button"
                            onClick={() => clickSubmit()}
                            className="btn-primary-premium"
                        >
                            {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );

    const clickSubmit = () => {
        sendMessageHelp(token, { userReceived, userSend, tilte, description }).then(data => {
            if (!data) {
            } else {
                setValues({
                    ...values,
                    userId: "",
                    tilte: "",
                    description: ""
                });
                setShowContactUs(false);
            }
        });
    };

    const printListeShop = () => (
        <div className="contact-modal-wrapper">
            <Modal
                size="xl"
                show={showContactUs}
                onHide={() => setShowContactUs(false)}
                dialogClassName="modal-premium"
                aria-labelledby="contact-modal-title"
                centered
            >
                <Modal.Header closeButton className="modal-header-premium">
                    <Modal.Title id="contact-modal-title" className="modal-title-premium">
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).messageElakayAdmin}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body-premium">
                    {newPostForm()}
                </Modal.Body>
            </Modal>
        </div>
    );

    const tocPortal = typeof document !== 'undefined'
        ? createPortal(
            <aside className="lp-toc-sidebar" aria-label={elakayAutoText("h_1a428989bd13dc", "Table of contents")}>
                <div className="lp-toc-inner">
                    <div className="lp-toc-header-row">
                        <p className="lp-toc-heading">{elakayAutoText("h_f5cbdf6bfb5143", "Contents")}</p>
                        <button
                            type="button"
                            className="lp-toc-minimize-btn"
                            onClick={() => setTocMinimized(m => !m)}
                            title={tocMinimized ? elakayAutoText("h_9869e506c38f64", "Expand") : elakayAutoText("h_1c5b768c8e72a0", "Minimize")}
                        >{tocMinimized ? '▢' : '−'}</button>
                    </div>
                    {!tocMinimized && (
                        <ol className="lp-toc-list">
                            {HC_TOC_ITEMS.map((item, i) => (
                                <li key={item.id} className={`lp-toc-item${activeTocId === item.id ? ' active' : ''}`}>
                                    <button
                                        type="button"
                                        className="lp-toc-link"
                                        onClick={() => handleTocClick(item.id)}
                                        aria-label={item.fallback}
                                    >
                                        <span className="lp-toc-num">{i + 1}</span>
                                        <span className="lp-toc-label">{elakayAutoText(item.key, item.fallback)}</span>
                                    </button>
                                </li>
                            ))}
                        </ol>
                    )}
                </div>
            </aside>,
            document.body
        )
        : null;

    return (
        <Layout
            infoSource={infoSource}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).helpContact.t003}
            description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
            className="container-fluid"
            loading={false}
            SliderPunShow={false}
            {...infoSource?.allSettings?.layout}
        >
            <div style={infoSource.styleNav}>
                <div className="policy-page-wrapper">
                    {/* All policy sections with premium styling */}
                    <div id="hc-s-0" className="policy-container">
                        <div className="policy-section">
                            {privacyPolicy()}
                        </div>
                    </div>

                    <div id="hc-s-1" className="policy-container">
                        <div className="policy-section">
                            {interpretationDefinitions()}
                        </div>
                    </div>

                    <div id="hc-s-2" className="policy-container">
                        <div className="policy-section">
                            {CollectingUsingYourPersonalData()}
                        </div>
                    </div>

                    <div id="hc-s-3" className="policy-container">
                        <div className="policy-section">
                            {DetailedInformationProcessingYourPersonalData()}
                        </div>
                    </div>

                    <div id="hc-s-4" className="policy-container">
                        <div className="policy-section">
                            {YourCaliforniaPrivacyRights()}
                        </div>
                    </div>

                    <div id="hc-s-5" className="policy-container">
                        <div className="policy-section">
                            {LinksOtherWebsites()}
                        </div>
                    </div>

                    <div id="hc-s-6" className="policy-container">
                        <div className="policy-section">
                            {ChangesthisPrivacyPolicy()}
                        </div>
                    </div>

                    <div id="hc-s-7" className="policy-container">
                        <div className="policy-contact">
                            {ContactUs()}
                        </div>
                    </div>

                    <div id="hc-s-8" className="policy-container">
                        <div className="policy-section">
                            {TermsConditions()}
                        </div>
                    </div>

                    <div id="hc-s-9" className="policy-container">
                        <div className="policy-section">
                            {ReturnAndRefundPolicy()}
                        </div>
                    </div>

                    <div id="hc-s-10" className="policy-container">
                        <div className="policy-section">
                            {InterpretationDefinitions()}
                        </div>
                    </div>

                    <div id="hc-s-11" className="policy-container">
                        <div className="policy-section">
                            {YourOrderCancellationRights()}
                        </div>
                    </div>

                    <div id="hc-s-12" className="policy-container">
                        <div className="policy-section">
                            {ConditionsReturns()}
                        </div>
                    </div>

                    <div id="hc-s-13" className="policy-container">
                        <div className="policy-section">
                            {ReturningGoods()}
                        </div>
                    </div>

                    <div id="hc-s-14" className="policy-container">
                        <div className="policy-section">
                            {Exchanges()}
                        </div>
                    </div>

                    <div id="hc-s-15" className="policy-container">
                        <div className="policy-section">
                            {Gifts()}
                        </div>
                    </div>

                    {printListeShop()}
                </div>
            </div>
            {tocPortal}
        </Layout>
    );
};

export default HelpContact;
